import { PromoBadge } from '@/components/PromoBadge';
import { useAddToBasket } from '@/hooks/useAddToBasket';
import type { Product } from '@/types';
import { buildCloudflareImageUrl } from '@/utils/buildCloudflareImageUrl';
import { ProductLink } from './ProductLink';
import * as Styled from './ProductTileModal.styled';

interface ProductTileModalProps {
  product: Product;
}

export const ProductTileModal = ({ product }: ProductTileModalProps) => {
  const { addToBasket, isPending } = useAddToBasket(product);

  const handleAddToBasket = () => {
    if (!isPending) {
      const payload = {
        code: product.sku,
        quantity: 1,
      };

      addToBasket(payload);
    }
  };

  const resizedImageSrc = buildCloudflareImageUrl(
    product.image?.thumbnailSrc ?? product.image?.mainSrc ?? '',
    { width: 172 },
  );

  if (!product.productUrl) {
    return null;
  }

  return (
    <Styled.ProductWrapper>
      <Styled.InnerWrapper>
        <Styled.ImageLinkWrapper>
          <Styled.ImageLink href={product.productUrl}>
            <img
              alt={(product.image?.altText || product.name) ?? ''}
              loading="lazy"
              src={resizedImageSrc}
            />
          </Styled.ImageLink>
          {product.promoBadge?.src ? (
            <PromoBadge
              altText={product.promoBadge.altText}
              src={product.promoBadge.src}
            />
          ) : null}
        </Styled.ImageLinkWrapper>
        <ProductLink product={product} />
      </Styled.InnerWrapper>
      <Styled.Cta
        $purchaseAction={product.purchaseAction}
        aria-label={`Add ${product.name} to cart.`}
        handler={handleAddToBasket}
        isPending={isPending}
      >
        Add to cart
      </Styled.Cta>
    </Styled.ProductWrapper>
  );
};
